import { render } from "./PageNotFound.vue?vue&type=template&id=5ffb7e53&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=5ffb7e53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffb7e53"]])

export default __exports__